import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import { API_AXIOS } from "../../http/interceptor";

export const invitationsApi = createApi({
  reducerPath: "invitationList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Invitations"],
  endpoints: (builder) => ({
    getInvitationsData: builder.query({
      queryFn: async ({
        page = 1,
        limit = 20,
        search,
        city,
        country,
        startDate,
        endDate,
        eventId,
        userId,
      }) => {
        try {
          const { data } = await API_AXIOS.get(Apis.invitation, {
            params: {
              page,
              limit,
              search,
              city,
              country,
              startDate,
              endDate,
              eventId,
              userId,
            },
          });
          return { data };
        } catch (error) {
          return { error: error.response?.data || error.message };
        }
      },
      providesTags: ["Invitations"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetInvitationsDataQuery } = invitationsApi;

export const inviDetailsApi = createApi({
  reducerPath: "invationDetails",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["invitationDetails"],
  endpoints: (builder) => ({
    getInviDetails: builder.query({
      query: (id) => ({
        url: `${Apis.invitation}/details/${id}`,
      }),
      providesTags: ["invitationDetails"],
      keepUnusedDataFor: 300,
      transformResponse: (data) => data.data,
    }),
  }),
});

export const { useGetInviDetailsQuery } = inviDetailsApi;

export const inviStatsApi = createApi({
  reducerPath: "invationStats",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["invationStats"],
  endpoints: (builder) => ({
    getInviStats: builder.query({
      query: () => ({
        url: Apis.invitationStats,
      }),
      providesTags: ["invationStats"],
      keepUnusedDataFor: 300,
      transformResponse: (data) => data.data,
    }),
  }),
});

export const { useGetInviStatsQuery } = inviStatsApi;

export const inviTopPerformers = createApi({
  reducerPath: "invitationTopPerformers",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["invitationTopPerformers"],
  endpoints: (builder) => ({
    getInviTopPerformers: builder.query({
      query: () => ({
        url: Apis.invitationTopPerformers,
      }),
      providesTags: ["invitationTopPerformers"],
      keepUnusedDataFor: 300,
      transformResponse: (data) => data.data,
    }),
  }),
});

export const { useGetInviTopPerformersQuery } = inviTopPerformers;
